class Menu {
  constructor() {
    $(document).ready(() => {
      this.initialize();
    })
  }

  initialize() {
    this.isMobile = window.innerWidth <= 768;
    this.items = document.querySelectorAll('.sticky-menu__list-item');
    this.indicator = document.querySelector('.sticky-menu__indicator');
    this.menuButton = document.querySelector('[data-menu-button]');
    this.menu = document.querySelector('.sticky-menu');
    this.location = window.location.pathname;
    this.isSupplyPage = !!document.querySelector('[data-supply-product]');
    this.isShopPage = !!document.querySelector('[data-shop-product]');
    
    this.resetClasses();

    this.setMenuItemClasses(this.location)
    
    this.items.forEach((item, index) => {
      this.setActiveClass(item, index)
    })

    this.menuButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.menu.classList.add('active')
    });

    $(this.items).on('click', () => {
      this.menu.classList.remove('active');
    });

    $('html').on('click', () => {
      if(this.menu.classList.contains('active')) {
        this.menu.classList.remove('active');
      }
    })
  }

  setMenuItemClasses(location, e) {
    if(e) {
      this.isSupplyPage = !!e.target.parentElement.hasAttribute('data-supply-link');
      this.isShopPage = !!e.target.parentElement.hasAttribute('data-shop-link');
      this.isHomePage = !!e.target.parentElement.classList.contains('home');
      this.isAboutPage = !!e.target.parentElement.classList.contains('about');
      this.isStudioPage = !!e.target.parentElement.classList.contains('studio');
      this.isContactPage = !!e.target.parentElement.classList.contains('contact');
    } else {
      this.isHomePage = location == '/';
      this.isStudioPage = location.includes('products/palette-studio');
      this.isAboutPage = location.includes('pages/about');
      this.isContactPage = location.includes('pages/contact');
    }

    this.resetClasses()
    
    if(this.isHomePage) {
      this.indicator.classList.add('home');
    } else if(this.isSupplyPage) {
      this.indicator.classList.add('supply');
    } else if(this.isShopPage) {
      $('main').css('background-color', '#fff');
      this.indicator.classList.add('shop');
    } else if(this.isStudioPage) {
      this.indicator.classList.add('studio')
    } else if(this.isAboutPage) {
      this.indicator.classList.add('about')
    } else if(this.isContactPage) {
      this.indicator.classList.add('contact')
    } else {
      this.indicator.classList.add('hidden')
    }
  }

  resetClasses() {
    this.indicator.classList.remove('studio')
    this.indicator.classList.remove('supply')
    this.indicator.classList.remove('home')
    this.indicator.classList.remove('about')
    this.indicator.classList.remove('shop')
    this.indicator.classList.remove('contact')
    this.indicator.classList.remove('hidden')
  }

  setActiveClass(item, index) {
    const href = item.querySelector('a').href.replace(location.origin, '');

    const width = window.innerWidth < 1024 ? 84 : 100;

    if(href == location.pathname) {
      item.classList.add('active');
      this.indicator.style.transform = `translateX(${width * index}px)`;
    } else if(href === '/collections/supply' && this.isSupplyPage) {
      item.classList.add('active')
      this.indicator.style.transform = `translateX(${width * index}px)`;
    } else if(href === '/collections/shop' && this.isShopPage) {
      item.classList.add('active');
      this.indicator.style.transform = `translateX(${width * index}px)`;
    } else {
      item.classList.remove('active')
    }
    
    item.addEventListener('click', (e) => {
      $('.sticky-menu__list-item').removeClass('active');
      item.classList.add('active');
      this.indicator.style.transform = `translateX(${width * index}px)`;
      this.setMenuItemClasses(item.querySelector('a').href, e)
    });
  }
};

const menu = new Menu();